var RenderReasons = require('renderreasons');
var User = require('user');
var UserMixins = require('usermixins');
var util = require('../lib/util.es6');
var IRCFormatter = require('ircformatter');


var Message = Backbone.Model.extend($.extend(true, {}, UserMixins, {
    idAttribute: 'eid',
    toString: function () {
        var string = '[' + this.getDate().formatTime();
        if (this.has('chan')) {
            string += ' ' + this.get('chan');
        }
        string += '] ';
        if (this.has('from')) {
            string += this.get('from') + ': ';
        }
        string += this.get('msg') || ('(' + this.get('type') + ')');
        if (this.get('nick')) {
            string += ' [' + this.get('nick') + ']';
        }
        if (this.get('name')) {
            string += ' <' + this.get('name') + '>';
        }
        return string;
    },
    initialize: function (data, options) {
        this.buffer = options.buffer;
        if (!this.buffer && this.collection) {
            this.buffer = this.collection.buffer;
        }
        if (this.buffer) {
            this.connection = this.buffer.connection;
        }
        if (this.collection) {
            this.collection.registerThread(this);
        }
    },
    clone: function () {
        return new Message(this.attributes, {
            buffer: this.buffer
        });
    },
    getCid: function () {
        return this.get('cid');
    },
    bid: function () {
        return this.get('bid');
    },
    getThreadBuf: function () {
        if (this.isInThreadCollection()) {
            return this.collection.thread;
        }
        if (this.buffer.isThread()) {
            return this.buffer;
        }
    },
    getEventId: function (eid) {
        var eventId = 'e' + this.bid() + '_' + this.id;
        var thread = this.getThreadBuf();
        if (thread) {
            eventId = eventId + '_t_' + thread.cid;
        }
        return eventId;
    },
    show: function () {
        this.trigger('show', this, {
            highlight: true
        });
    },
    isHighlight: function () {
        return this.get('highlight');
    },
    isImportantHighlight: function () {
        return this.isImportant() && this.isHighlight();
    },
    getNick: function () {
        return this.get('newnick') || this.get('from') || this.get('nick');
    },
    isPrivmsg: function () {
        return this.get('type') === 'buffer_msg';
    },
    isMeMsg: function () {
        return this.get('type') === 'buffer_me_msg';
    },
    isIgnorable: function () {
        return Message.isIgnorable(this.get('type'));
    },
    isEmpty: function () {
        return Message.isEmpty(this.get('type')) ||
            (this.isAttachmentFallback() && !this.hasAttachment()) ||
            !!this.getConcatTag() ||
            !!this.getEdit() ||
            (this.isDeletedOrRedacted() && !this.buffer.isShowingDeletedMessages());
    },
    getConcatId: function () {
        return this.getConcatTag() || this.getMsgId();
    },
    hasConcatTag: function () {
        var clientTags = this.getClientTags();
        return '+draft/concat-start' in clientTags ||
            '+draft/concat' in clientTags ||
            '+draft/concat-line' in clientTags ||
            '+draft/concat-end' in clientTags;
    },
    getConcatTag: function () {
        var clientTags = this.getClientTags();
        return clientTags['+draft/concat'] || clientTags['+draft/concat-line'];
    },
    getConcat: function () {
        var clientTags = this.getClientTags();
        return clientTags['+draft/concat'];
    },
    getConcatLine: function () {
        var clientTags = this.getClientTags();
        return clientTags['+draft/concat-line'];
    },
    setConcatStart: function () {
        var props = {};
        if (!this.getMsgId()) {
            props.msgid = this.id;
            this.fakeMsgId = true;
        }
        var entities = this.getEntities();
        var clientTags = this.getClientTags();
        clientTags['+draft/concat-start'] = true;
        entities.client_tags = clientTags;
        props.entities = entities;
        this.set(props);
    },
    setConcatLine: function (msgid, end) {
        var entities = this.getEntities();
        var clientTags = this.getClientTags();
        clientTags['+draft/concat-line'] = msgid;
        if (end) {
            clientTags['+draft/concat-end'] = true;
        }
        entities.client_tags = clientTags;
        this.set({entities: entities});
    },
    concat: function (message) {
        var concats = this.get('concats') || {};
        if (message.id in concats) {
            return false;
        }
        concats[message.id] = message;
        var newMsg = this.get('msg');
        if (message.getConcatLine()) {
            newMsg += '\n';
        }
        this.concatMentions(message, newMsg.length);
        newMsg += message.get('msg');
        this.set({
            msg: newMsg,
            concats: concats
        });
        return true;
    },
    getReplyId: function () {
        return this.getReply() || this.getMsgId();
    },
    getMsgId: function () {
        if (this.has('msgid')) {
            return this.get('msgid');
        }
        var twitchTags = this.getTwitchTags();
        if (twitchTags) {
            return twitchTags['id'];
        }
    },
    getReaction: function () {
        return this.getEntities().react || this.getKnownClientTags().react;
    },
    getUnreaction: function () {
        return this.getEntities().unreact || this.getKnownClientTags().unreact;
    },
    getReactionImage: function () {
        var image = this.getEntities().react_image || this.getClientTags()['+draft/react-image'];
        if (image && image.match(/https:\/\/.+/)) {
            return image;
        }
    },
    getReplyTag: function () {
        return this.getEntities().reply || this.getKnownClientTags().reply;
    },
    getReply: function () {
        var reply = this.getReplyTag();
        if (reply) {
            return reply;
        }
        var twitchTags = this.getTwitchTags();
        if (twitchTags) {
            return twitchTags['reply-parent-msg-id'];
        }
    },
    quoteReplyString: function () {
        var reply = this.getReplyId();
        if (reply) {
            var replyMessage = this.buffer.messages.findByMsgId(reply);
            if (replyMessage && replyMessage.isEmpty()) {
                return;
            }
            var string = 'Replying to ';
            if (replyMessage) {
                string += replyMessage.getDisplayName();
                string += ': ' + util.truncate(replyMessage.get('msg'), 120);
            } else {
                string += 'an earlier message';
            }
            return string;
        }
        var twitchTags = this.getTwitchTags();
        if (twitchTags && 'reply-parent-display-name' in twitchTags) {
            var twitchString = 'Replying to @' + twitchTags['reply-parent-display-name'];
            if ('reply-parent-msg-body' in twitchTags) {
                twitchString += ': ' + util.truncate(twitchTags['reply-parent-msg-body'], 120);
            }
            return twitchString;
        }
    },
    isInThread: function () {
        if (this.isInThreadCollection()) {
            return true;
        }
        if (this.getReply()) {
            return true;
        }
        var msgId = this.getMsgId();
        if (msgId && this.collection) {
            return this.collection.isInThread(msgId);
        }
        return false;
    },
    isReplyTargetSelf: function () {
        var reply = this.getReply();
        if (!reply) {
            return false;
        }
        var target = this.buffer.messages.findByMsgId(reply);
        if (target && target.isSelf()) {
            return true;
        }
        return false;
    },
    isInThreadCollection: function () {
        return !!this.collection && !!this.collection.thread;
    },
    isSameThread: function (message, replyId) {
        var buf = this.getThreadBuf();
        if (buf && buf == message.getThreadBuf()) {
            return true;
        }
        if (!replyId) {
            replyId = this.getReplyId();
        }
        return replyId === message.getReplyId() || replyId == message.getMsgId();
    },
    getReplies: function () {
        return this.getThread(true).slice(1);
    },
    getThread: function (excludeEmpty) {
        var replyId = this.getReplyId();
        if (replyId && this.collection) {
            return this.collection.getThread(replyId, excludeEmpty);
        }
        return [this];
    },
    isConcatenation: function (message, concatId) {
        if (!concatId) {
            concatId = this.getConcatId();
        }
        return concatId === message.getConcatId();
    },
    getConcatParent: function () {
        var concatId = this.getConcatTag();
        if (concatId && this.collection) {
            return this.collection.find(function (m) {
                return concatId === m.getMsgId();
            });
        }
    },
    getConcats: function () {
        var concatId = this.getConcatId();
        var msgIds = {};
        if (concatId && this.collection) {
            return this.collection.filter(function (m) {
                if (this.isConcatenation(m, concatId)) {
                    if (m.getMsgId()) {
                        msgIds[m.getMsgId()] = true;
                    }
                    return true;
                } else if (msgIds[m.getConcatId()]) {
                    return true;
                }
            }, this);
        }
        return [this];
    },
    isEditable: function () {
        return (
            this.buffer.connection.hasReliableClientTags() &&
            !this.buffer.connection.blocksEdits() &&
            this.doIsEditable()
        );
    },
    doIsEditable: function () {
        return !this.fakeMsgId &&
            this.has('msgid') &&
            Message.isEditable(this.get('type'));
    },
    doIsDeletable: function () {
        return !this.fakeMsgId &&
            this.has('msgid') &&
            Message.isDeletable(this.get('type'));
    },
    isRedactable: function () {
        return this.buffer.connection.hasRedaction() && (
            this.hasSameAccount(this.buffer.user) || (
                this.buffer.userMember && this.buffer.userMember.canOp()
            )
        );
    },
    isDeletable: function () {
        return (
            this.buffer.connection.hasReliableClientTags() &&
            !this.buffer.connection.blocksDeletes() &&
            this.doIsDeletable() &&
            this.hasSameAccount(this.buffer.user)
        );
    },
    isReplyable: function () {
        return (
            this.buffer.connection.hasReliableClientTags() &&
            !this.buffer.connection.blocksReplies() &&
            this.doIsReplyable()
        );
    },
    doIsReplyable: function () {
        return !this.fakeMsgId && this.has('msgid') && Message.isReplyable(this.get('type'));
    },
    isTwitchReplyable: function () {
        return !this.fakeMsgId && Message.isReplyable(this.get('type'));
    },
    isReactable: function () {
        return (
            this.buffer.connection.hasReliableClientTags() &&
            !this.buffer.connection.blocksReactions() &&
            this.doIsReactable()
        );
    },
    doIsReactable: function () {
        return !this.fakeMsgId && this.has('msgid') && Message.isReactable(this.get('type'));
    },
    isTopLevel: function () {
        return !this.getReply();
    },
    isClientTaggable: function () {
        return Message.isClientTaggable(this.get('type'));
    },
    areEmbedsAllowed: function () {
        return Message.areEmbedsAllowed(this.get('type'));
    },
    getReplacements: function () {
        var twitchEmotes = this.getTwitchEmotes() || [];
        var customEmoji = this.getCustomEmoji() || [];
        var mentions = this.getMentions() || [];
        var replacements = mentions.concat(customEmoji).concat(twitchEmotes);
        if (replacements.length) {
            replacements.sort(function (a, b) {
                var aOffset = a.startOffset || 0;
                var aStart = aOffset + (a.start);
                var bOffset = b.startOffset || 0;
                var bStart = bOffset + (b.start);
                return aStart - bStart;
            });
            return replacements;
        }
    },
    concatMentions: function (message, startOffset) {
        var mentions = message.getMentions();
        if (mentions) {
            if (!this.mentionConcats) {
                this.mentionConcats = [];
            }
            _.each(mentions, function (mentionOffset) {
                mentionOffset.startOffset = startOffset;
                this.mentionConcats.push(mentionOffset);
            }, this);
        }
    },
    getMentionData: function () {
        return this.getEntities().mention_data || {};
    },
    getMentions: function () {
        var mentions = this.getEntities().mentions;
        if (!this.mentionConcats && (!mentions || !$.isPlainObject(mentions))) {
            return;
        }
        var offsets = [];
        // {
        //     nick: [
        //         [0,4],
        //         [5,4]
        //     ]
        // }
        _.each(mentions, function (idx, nick) {
            if (!nick || !idx || !_.isArray(idx)) {
                return;
            }
            _.each(idx, function (idxOffset) {
                if (!idxOffset || !_.isArray(idxOffset) || idxOffset.length !== 2) {
                    return;
                }
                var start = idxOffset[0]-0;
                var length = idxOffset[1]-0;
                offsets.push({
                    type: 'mention',
                    nick: nick,
                    start: start,
                    end: start + length
                });
            });
        });
        if (offsets.length || this.mentionConcats) {
            return (offsets || []).concat(this.mentionConcats || []);
        }
    },
    getEmojiTag: function () {
        return this.getEntities().emoji || this.getClientTags()['+draft/emoji'];
    },
    getCustomEmoji: function () {
        var customEmoji = this.getEmojiTag();
        if (!customEmoji) {
            return;
        }
        var customEmojiJson;
        if (_.isArray(customEmoji)) {
            customEmojiJson = customEmoji;
        } else {
            try {
                customEmojiJson = JSON.parse(customEmoji);
            } catch (exc) {
                // pass
            }
        }
        return Message.getCustomEmoji(customEmojiJson);
    },
    getTwitchEmotes: function () {
        var twitchTags = this.getTwitchTags();
        if (!twitchTags || !twitchTags.emotes) {
            return;
        }
        var offsets = [];
        // Twitch counts the characters '/me ' as part of the message
        var adjustment = this.isMeMsg() ? 4 : 0;
        _.each(twitchTags.emotes.split('/'), function (token) {
            var bounds = token.match(/^(\d+):((?:\d+-\d+,?)+)$/);
            if (bounds) {
                _.each(bounds[2].split(','), function(offsetPair) {
                    var offset = offsetPair.split('-');
                    var bound = {
                        type: 'twitch_emote',
                        emote: bounds[1]-0,
                        start: offset[0]-adjustment,
                        end: (offset[1]-adjustment) + 1
                    };
                    if (bound.end > bound.start) {
                        offsets.push(bound);
                    }
                });
            }
        });
        if (offsets.length) {
            return offsets;
        }
    },
    getEmbeds: function () {
        return !this.isPending() && (this.get('entities') || this.areEmbedsAllowed());
    },
    getEntities: function () {
        return this.get('entities') || {};
    },
    getClientTags: function () {
        return this.getEntities().client_tags || {};
    },
    getKnownClientTags: function () {
        return this.getEntities().known_client_tags || {};
    },
    getTwitchTags: function () {
        return this.getEntities().twitch_tags;
    },
    getRawHostmask: function () {
        return this.get('hostmask') || this.get('usermask');
    },
    getRawIdent: function () {
        return this.get('from_user');
    },
    getRawHost: function () {
        return this.get('from_host');
    },
    getAccount: function () {
        return this.fallbackValue('target_account', 'from_account', 'account');
    },
    getRealname: function () {
        return this.fallbackValue('target_realname', 'from_realname', 'realname');
    },
    fallbackValue: function (key, fallback1, fallback2) {
        var value = this.get(key);
        if (!value && !this.isUserChannelMode()) {
            var fallback = this.get(fallback1);
            if (!fallback && fallback2) {
                fallback = this.get(fallback2);
            }
            return fallback || value;
        }
        return value;
    },
    isIgnored: function (options) {
        if (!this.isIgnorable()) {
            return false;
        }
        return this.connection.isIgnored(this.getNick(), this.getHostMask(), options);
    },
    isInCollapsedThread: function () {
        var reply = this.getReply();
        if (reply) {
            return this.buffer.isThreadCollapsed(reply);
        }
        return false;
    },
    isImportant: function () {
        // Self messages aren't important
        if (this.isSelf()) {
            return false;
        }
        if (this.isEmpty()) {
            return false;
        }
        if (this.isNotice() || this.isChannelInvite()) {
            // Notices sent from the server (with no nick sender) aren't important
            // e.g. *** Looking up your hostname...
            if (!this.get('from')) {
                return false;
            }
            // Notices or channel invites sent to a buffer aren't important in the server buffer
            if (this.buffer.isServerLog() && (this.get('to_chan') || this.get('to_buffer'))) {
                return false;
            }
        }
        return _.include(Message.important, this.get('type'));
    },
    isNotice: function () {
        return this.get('type') == 'notice';
    },
    isChannelInvite: function () {
        return this.get('type') == 'channel_invite';
    },
    isNotableExempt: function () {
        return this.isSelf() || !this.isImportant() || this.isIgnored();
    },
    isNotable: function () {
        // Don't notify on self, unimportant messages or ignored messages
        if (this.isNotableExempt()) {
            return false;
        }
        if (this.buffer.shouldMuteNotifications()) {
            return false;
        }
        return this.isHighlightable() ||
               (this.buffer.isChannel() && this.buffer.shouldNotifyAll() && !this.isNotice());
    },
    isHighlightable: function () {
        // Don't notify on self, unimportant messages or ignored messages
        if (this.isNotableExempt()) {
            return false;
        }
        if (this.buffer.shouldMuteNotifications()) {
            return false;
        }
        return this.isHighlight() ||
            (
                (
                    this.buffer.isConversation() || 
                    (this.buffer.isChannel() && this.buffer.isSlackMultiPersonDm())
                ) &&
                this.buffer.isTrackingUnread() &&
                !this.isNotice()
            ) ||
            this.isChannelInvite() ||
            this.get('type') == 'callerid' ||
            this.get('type') == 'wallops';
    },
    equals: function (eid) {
        if (eid instanceof Message) {
            eid = eid.id;
        }
        return this.id == eid;
    },
    isSelf: function () {
        return !!this.get('self');
    },
    isThrottlable: function () {
        return this.isSelf() &&
            !this.isThrottled() &&
            _.include(Message.throttlable, this.get('type'));
    },
    isThrottled: function () {
        return !!this.get('throttled');
    },
    markAsThrottled: function () {
        this.set('throttled', true);
    },
    isPending: function () {
        return !!this.get('_pendingreqid');
    },
    isEphemeral: function () {
        return !!this.get('ephemeral');
    },
    isJoinPart: function () {
        return _.include(Message.joinPart, this.get('type')) ||
            this.isNickModeListChange();
    },
    isHideableJoinPart: function () {
        return _.include(Message.hideableJoinPart, this.get('type'));
    },
    isUserChannelMode: function () {
        return this.get('type') == 'user_channel_mode';
    },
    isChannelMode: function () {
        return this.get('type') == 'channel_mode';
    },
    isNickModeListChange: function () {
        if (this.get('type') != 'channel_mode_list_change') {
            return false;
        }
        var opList = this.get('ops').add.length ? this.get('ops').add : this.get('ops').remove;
        if (opList.length) {
            var op = opList[0];
            if (op.mode == 'a') {
                // protected
                return true;
            }
            if (op.mode == 'q' && op.param.indexOf('@') === -1 && op.param.indexOf('$') === -1) {
                // If just a nick then this is an owner
                // quiet masks always have @
                // extbans always have $
                return true;
            }
        }
        return false;
    },

    makeUser: function (nick) {
        if (nick === undefined) {
            nick = this.getNick();
        }
        return new User({
            nick: nick,
            usermask: this.fallbackValue('target_hostmask', 'hostmask', 'usermask'),
            ident_prefix: this.fallbackValue('target_ident_prefix', 'ident_prefix'),
            user: this.fallbackValue('target_name', 'from_name'),
            userhost: this.fallbackValue('target_host', 'from_host'),
            mode: this.isChannelMode() ? this.get('from_mode') : this.fallbackValue('newmode', 'from_mode'),
            account: this.getAccount(),
            realname: this.getRealname(),
            avatar: this.fallbackValue('target_avatar', 'avatar'),
            avatar_url: this.fallbackValue('target_avatar_url', 'avatar_url'),
            display_name: this.fallbackValue('target_display_name', 'display_name'),
            bot_url: this.fallbackValue('target_bot_url', 'bot_url')
        }, {
            session: this.buffer.session,
            connection: this.connection,
            buffer: this.buffer,
            message: this
        });
    },
    isDisconnect: function () {
        return _.include(Message.disconnect, this.get('type'));
    },
    getDisconnectMessage: function () {
        var msg = '';
        var reason = this.get('reason');
        switch (this.get('type')) {
        case 'socket_closed':
            if (this.get('timedout')) {
                msg = "Connection timed out";
            } else if (this.get('pool_lost')) {
                msg = "Connection pool lost";
            } else if (this.get('crash')) {
                msg = "Connection crashed";
            } else if (this.get('abnormal')) {
                msg = "Connection closed unexpectedly";
            } else if (this.get('limited')) {
                msg = "Connection restricted";
            }
            if (reason) {
                if (msg) {
                    msg += ': ';
                }
                msg += RenderReasons.render(reason);
            }
            break;
        case 'connecting_failed':
            if (reason == 'ssl_verify_error') {
                msg = 'Strict transport security error';
                var verifyError = RenderReasons.renderSSLVerify(this.get('ssl_verify_error'));
                if (verifyError) {
                    msg += ': ' + verifyError;
                }
            } else {
                msg = 'Failed to connect: ' + RenderReasons.render(reason);
            }
            break;
        case 'connecting_cancelled':
            if (this.get('sts')) {
                msg = 'Upgrading connection security';
            } else {
                msg = 'Cancelled';
            }
            break;
        }
        if (this.get('limited')) {
            msg += ' (' + RenderReasons.renderRestrictedShort(this.get('limited')) + ')';
        }
        if (this.get('give_up')) {
            msg += ' (gave up)';
        }
        return msg;
    },
    getTime: function () {
        if (this.get('server_time')) {
            return this.get('server_time');
        }
        if (this.id) {
            return this.buffer.session.backend.tsOffset(this.id / 1000);
        }
    },
    getDate: function () {
        var time = this.getTime();
        if (time) {
            return new Date(time);
        }
    },
    index: function () {
        if (this.collection) {
            return this.collection.indexOf(this);
        }
    },
    areBothJoinPart: function (message) {
        if (message) {
            return this.isJoinPart() && message.isJoinPart();
        }
    },
    areBothDisconnect: function (message) {
        if (message) {
            return this.isDisconnect() && message.isDisconnect();
        }
    },
    previousReplyable: function (differentThread) {
        var replyId = this.getReplyId();
        var prev = this.previousMessage();
        while (prev && (
            !prev.isReplyable() ||
            (differentThread && this.isSameThread(prev, replyId))
        )) {
            prev = prev.previousMessage();
        }
        return prev;
    },
    nextReplyable: function (differentThread) {
        var replyId = this.getReplyId();
        var next = this.nextMessage();
        while (next && (
            !next.isReplyable() ||
            (differentThread && this.isSameThread(next, replyId))
        )) {
            next = next.nextMessage();
        }
        return next;
    },
    previousVisible: function () {
        if (this._previousMessage) {
            return this._previousMessage;
        }
        var prev = this.previousMessage();
        while (prev && prev.isEmpty()) {
            prev = prev.previousMessage();
        }
        return prev;
    },
    nextVisible: function () {
        if (this._nextMessage) {
            return this._nextMessage;
        }
        var next = this.nextMessage();
        while (next && next.isEmpty()) {
            next = next.nextMessage();
        }
        return next;
    },
    previousMessage: function () {
        if (this._previousMessage) {
            return this._previousMessage;
        }
        if (this.collection) {
            return this.collection.previous(this);
        }
    },
    nextMessage: function () {
        if (this._nextMessage) {
            return this._nextMessage;
        }
        if (this.collection) {
            return this.collection.next(this);
        }
    },
    hasSlackBlocks: function () {
        return this.getSlackBlocks().length > 0;
    },
    getSlackBlocks: function () {
        var blocks = this.getEntities().slack_blocks || [];
        return _.filter(blocks, function (b) {
            return b.type !== 'rich_text';
        });
    },
    getAttachmentsTag: function (editFallback) {
        return this.getEntities().attachments ||
            this.getClientTags()['+draft/attachments'] ||
            (editFallback && this.getClientTags()['+draft/edit-attachments']);
    },
    hasAttachment: function () {
        return this.getAttachmentsJson().length > 0;
    },
    getAttachmentsJson: function () {
        var attachTag = this.getAttachmentsTag();
        if (!_.isArray(attachTag)) {
            var attach = [];
            try {
                attach = JSON.parse(attachTag);
            } catch (exc) {
                attach = [];
            }
            if (!_.isArray(attach)) {
                attach = [];
            }
            var entities = this.getEntities();
            entities.attachments = attach;
            this.set('entities', entities);
            attachTag = attach;
        }
        var suppress = false;
        return _.filter(attachTag, function (att) {
            if (!att || suppress) {
                return false;
            }
            switch (att.service_name) {
            case 'twitter':
            case 'X (formerly Twitter)':
                suppress = true;
                return false;
            case 'Imgur':
            case 'Gfycat':
                return false;
            default:
                return true;
            }
        });
    },
    isAttachmentFallback: function () {
        return !!this.getEntities().attachment_fallback ||
            ('+draft/attachment-fallback' in this.getClientTags());
    },
    getAvatar: function () {
        return UserMixins.getAvatar.call(this, {
            avatar_url: this.getEntities().icon,
            noGravatar: !!this.getTagDisplayName() && !!this.parseDisplayAuthor()
        });
    },
    hasSameAuthor: function (message) {
        return !!(
            message &&
            message.get('type') == this.get('type') &&
            message.get('from') == this.get('from') &&
            message.get('target') == this.get('target') &&
            message.channelContext() == this.channelContext() &&
            _.isEqual(message.getRealname(), this.getRealname()) &&
            _.isEqual(message.getAvatar(), this.getAvatar()) &&
            message.getDisplayAuthor() == this.getDisplayAuthor() &&
            this.hasSameDate(message)
        );
    },
    hasSameAccount: function (message) {
        var account = this.getAccount();
        if (account && account != '*') {
            return account === message.getAccount();
        }
        return false;
    },
    getRedact: function () {
        if (this.get('type') == 'redact') {
            return this.get('redact_msgid');
        }
    },
    getDelete: function () {
        return this.getEntities()['delete'] || this.getClientTags()['+draft/delete'];
    },
    delete: function () {
        if (this.collection) {
            this.collection.remove(this);
        } else {
            this.trigger('remove');
        }
    },
    canDelete: function (message) {
        return this.getEntities()['server_delete'] || this.hasSameAccount(message) || !!this.getRedact();
    },
    getEdit: function () {
        return this.getEntities().edit || this.getClientTags()['+draft/edit'];
    },
    getEditOrig: function () {
        var edits = this.get('edits');
        return _.find(this.get('edits'), function (m, eid) {
            return m.get('previous_msg');
        });
    },
    getEditText: function () {
        return this.getEntities().edit_text || this.getClientTags()['+draft/edit-text'];
    },
    redact: function (message) {
        this.set('redacted', message);
        return true;
    },
    isRedacted: function () {
        return !!this.getRedacted();
    },
    getRedacted: function () {
        return this.get('redacted');
    },
    remove: function (message) {
        this.set('deleted', message);
        return true;
    },
    getDeletion: function () {
        return this.get('deleted');
    },
    isDeleted: function () {
        return !!this.get('deleted');
    },
    isDeletedOrRedacted: function () {
        return this.isDeleted() || this.isRedacted();
    },
    edit: function (message) {
        var edits = this.get('edits') || {};
        if (message.id in edits) {
            return false;
        }
        edits[message.id] = message;
        var props = {
            edits: edits
        };
        var editClientTags = message.getClientTags();
        var editEntities = message.getEntities();
        var editText = message.getEditText();
        var entities = this.getEntities();
        if (editText) {
            message.set('previous_msg', this.get('msg'));
            props.msg = editText;
            entities.attachment_fallback = false;
        }
        var editAttach = message.getAttachmentsTag(true);
        entities.attachments = editAttach;

        var editEmoji = message.getEmojiTag();
        if (this.mentionConcats && (editText || editEmoji)) {
            delete this.mentionConcats;
        }
        var editMentions = message.getEntities().mentions;
        if (editMentions || entities.mentions || editEmoji) {
            // Reset mentions from edit message
            if (editText || editEmoji) {
                entities.mentions = editMentions;
            }
            if (editEmoji) {
                entities.emoji = editEmoji;
            }
            props.entities = entities;
        }
        if (!_.isEmpty(props)) {
            this.set(props);
        }
        return true;
    },
    getUserDisplayName: function () {
        return this.get('display_name');
    },
    isBot: function () {
        return !!this.getEntities().bot || this.isRelayBot();
    },
    isRelayBot: function () {
        return this.connection.isRelayBot(this.getNick());
    },
    channelContext: function () {
        return this.get('channel_context');
    },
    relayMsgRelay: function () {
        return this.getEntities().relaymsg;
    },
    relayMsgParts: function (name) {
        var parts = {
            nick: name
        };
        var relay = this.relayMsgRelay();
        if (relay) {
            parts.relay = relay;
            if (this.connection) {
                var separator = this.connection.getRelayMsgSeparator();
                if (separator) {
                    var splitParts = name.split(separator);
                    parts.nick = splitParts[0];
                    parts.server = splitParts[1];
                }
            }
        }
        return parts;
    },
    getTagDisplayName: function () {
        var ent = this.getEntities().displayname;
        if (ent) {
            return ent;
        }
        var ct = this.getClientTags()['+draft/displayname'];
        if (ct) {
            return ct;
        }
    },
    parseDisplayAuthor: function () {
        if (!this.isRelayBot()) {
            return;
        }
        var match = this.matchRelayBot();
        if (match) {
            return match[1];
        }
    },
    matchRelayBot: function () {
        if (!this.isPrivmsg() && !this.isMeMsg() && !this.isNotice()) {
            return;
        }
        if (!this.get('msg')) {
            return;
        }
        var stripped = IRCFormatter.strip(IRCFormatter.stripZWSP(this.get('msg')));
        return stripped.match(/^<([^>]+)>:? /) || stripped.match(/^`([^`]+)`:? /) || stripped.match(/^\[([^\]]+)\]:? /);
    },
    getMessageDisplayName: function () {
        var dn = this.getTagDisplayName();
        if (dn) {
            return dn;
        }
        var twitchTags = this.getTwitchTags();
        if (twitchTags) {
            return twitchTags['display-name'];
        }
        if (this.isRelayBot()) {
            return this.parseDisplayAuthor();
        }
    },
    getDisplayAuthor: function () {
        var dn = this.getMessageDisplayName();
        if (dn) {
            return dn;
        }
        return this.getUserDisplayName();
    },
    getDisplayName: function () {
        return this.getDisplayAuthor() || this.getNick() || this.get('server');
    },
    hasSameDate: function (date) {
        if (date) {
            if (date instanceof Message) {
                date = date.getDate();
            }
            return this.getDate().isSameDay(date);
        }
    },
    hasSameDateAsNext: function () {
        return this.hasSameDate(this.nextMessage());
    },
    hasSameDateAsPrevious: function () {
        return this.hasSameDate(this.previousMessage());
    },
    isAfter: function (message) {
        return this.id > message.id;
    },
    isBefore: function (message) {
        return this.id < message.id;
    },
    isLastSeen: function () {
        return this.id == this.buffer.getLastSeen();
    },
    isNetSplit: function () {
        if (this.get('type') !== 'quit') {
            return false;
        }
        return Message.isNetSplit(this.get('msg'));
    },
    isOnlyEmojiNative: function () {
        return this.isOnlyEmoji(true);
    },
    isOnlyEmoji: function (nativeOnly) {
        var customEmoji = this.getCustomEmoji() || [];
        var msg = this.get('msg');
        var value = msg;
        var index = 0;
        var stripped = '';
        _.each(customEmoji, function (replacement) {
            var rStart = replacement.start;
            var rEnd = replacement.end;
            if (
                rStart >= 0 &&
                rStart <= msg.length &&
                rEnd <= msg.length
            ) {
                stripped += util.stringSlice(msg, index, rStart);
                value = util.stringSlice(msg, rEnd);
                index = rEnd;
            }
        });
        stripped += value;
        stripped = stripped.trim();
        if (!nativeOnly) {
            stripped = emoji.replace_colons(stripped, true);
        }
        return emoji.strip_unified(stripped) === '';
    }
}), {
    LONG_MESSAGE_LIMIT: 7200,
    THROTTLE_RE: /\*\*\* Message to (#[^\s]+) throttled due to flooding/,
    NETSPLIT_RE: /^(?:[^\s:\/.]+\.)+[a-z]{2,} (?:[^\s:\/.]+\.)+[a-z]{2,}$/i,
    checkThrottleChan: function (msg) {
        var match = msg.match(Message.THROTTLE_RE);
        if (match) {
            return match[1];
        }
    },
    isNetSplit: function (msg) {
        // From irssi 0.8.15
    /* NOTE: there used to be some paranoia checks (some older IRC
       clients have even more), but they're pretty useless nowadays,
       since IRC server prefixes the quit message with a space if it
       looks like a netsplit message.

       So, the check is currently just:
             - host1.domain1 host2.domain2
             - top-level domains have to be 2+ characters long,
           containing only alphabets
         - only 1 space
         - no double-dots (".." - probably useless check)
         - hosts/domains can't start or end with a dot
             - the two hosts can't be identical (probably useless check)
         - can't contain ':' or '/' chars (some servers allow URLs) */
        if ((Message.NETSPLIT_RE).test(msg)) {
            var parts = msg.split(' ');
            if (parts[0] !== parts[1]) {
                return true;
            }
        }
        return false;
    },
    isIgnorable: function (type) {
        return _.include(Message.ignorable, type);
    },
    isEmpty: function (type) {
        return _.include(Message.empty, type);
    },
    isReactable: function (type) {
        return _.include(Message.reactable, type);
    },
    isEditable: function (type) {
        return _.include(Message.editable, type);
    },
    isDeletable: function (type) {
        return _.include(Message.deletable, type);
    },
    isReplyable: function (type) {
        return _.include(Message.replyable, type);
    },
    isClientTaggable: function (type) {
        return _.include(Message.client_tag_types, type);
    },
    areEmbedsAllowed: function (type) {
        return _.include(Message.embeds_allowed, type);
    },

    getCustomEmoji: function (customEmojiJson) {
        if (!customEmojiJson || !_.isArray(customEmojiJson)) {
            return;
        }
        var offsets = [];
        // [{
        //     url: 'https://example.com/emoji.png',
        //     idx: [
        //         [0,4],
        //         [5,4]
        //     ]
        // }]
        _.each(customEmojiJson, function (json) {
            if (!json.url || !json.url.match(/https:\/\/.+/)) {
                return;
            }
            if (!json.idx || !_.isArray(json.idx)) {
                return;
            }
            _.each(json.idx, function (jsonOffset) {
                if (!jsonOffset || !_.isArray(jsonOffset) || jsonOffset.length !== 2) {
                    return;
                }
                var start = jsonOffset[0]-0;
                var length = jsonOffset[1]-0;
                offsets.push({
                    type: 'emoji',
                    url: json.url,
                    start: start,
                    end: start + length
                });
            });
        });
        if (offsets.length) {
            offsets.sort(function (a, b) {
                return a.start - b.start;
            });
            return offsets;
        }
    },
    hideableJoinPart: [
        'joined_channel',
        'parted_channel',
        'quit',
        'user_channel_mode',
        'nickchange'
    ],
    joinPart: [
        'you_joined_channel',
        'joined_channel',
        'parted_channel',
        'quit',
        'user_channel_mode',
        'nickchange',
        'channel_mode_is',
        'channel_url',
        'user_chghost'
    ],
    disconnect: [
        'socket_closed',
        'connecting_failed',
        'connecting_cancelled'
    ],
    ignorable: [
        'buffer_msg',
        'buffer_me_msg',
        'notice',
        'channel_invite',
        'callerid',
        'wallops'
    ],
    important: [
        'buffer_msg',
        'buffer_me_msg',
        'notice',
        'channel_invite',
        'callerid',
        'wallops'
    ],
    empty: [
        'redact',
        'empty_msg',
        'empty_notice',
        'backlog_cache_init'
    ],
    throttlable: [
        'buffer_msg',
        'buffer_me_msg'
    ],
    editable: [
        'buffer_msg',
        'notice'
    ],
    deletable: [
        'buffer_msg',
        'buffer_me_msg',
        'notice'
    ],
    replyable: [
        'buffer_msg',
        'buffer_me_msg',
        'notice'
    ],
    reactable: [
        'buffer_msg',
        'buffer_me_msg',
        'notice',
        'you_joined_channel',
        'joined_channel',
        'you_parted_channel',
        'parted_channel',
        'quit',
        'nickchange'
    ],
    client_tag_types: [
        'redact',
        'empty_msg',
        'empty_notice',
        'buffer_msg',
        'buffer_me_msg',
        'notice'
    ],
    embeds_allowed: [
        'buffer_msg',
        'buffer_me_msg',
        'twitch_usernotice',
        'notice'
    ]
});


module.exports = Message;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/message.js
// module id = j9Sh
// module chunks = 1